import { RequestHeader } from './request-offer/request-header.model';

export class OffersState {
  offersCounter: number;
  offersTotalNumber: number;
  displayedOffersNumber: number;
  offersHeaders: RequestHeader[];

  constructor() {
  }
}
